import { User } from '@/domain/entities/User';
import type { UserDTO } from '@/application/dtos/auth/AuthDTO';

export class UserMapper {
  static toDomain(dto: UserDTO): User {
    return User.create(
      dto.id,
      dto.username,
      dto.email,
      dto.role,
      dto.tenant || null,
      dto.createdAt ? new Date(dto.createdAt) : new Date(),
      dto.lastLogin ? new Date(dto.lastLogin) : undefined,
      Boolean(dto.mustChangePassword)
    );
  }

  static toDTO(user: User): UserDTO {
    return {
      id: user.id.getValue(),
      username: user.username,
      email: user.email.getValue(),
      role: user.role,
      tenant: user.getTenant() ? {
        id: user.getTenant()!.id.getValue(),
        nombre: user.getTenant()!.nombre,
      } : undefined,
      createdAt: user.createdAt.toISOString(),
      lastLogin: user.lastLogin?.toISOString(),
      mustChangePassword: user.mustChangePassword,
    };
  }
}
